import { render, staticRenderFns } from "./ChooseProfile.vue?vue&type=template&id=a4469dcc&scoped=true"
import script from "./ChooseProfile.vue?vue&type=script&lang=js"
export * from "./ChooseProfile.vue?vue&type=script&lang=js"
import style0 from "./ChooseProfile.vue?vue&type=style&index=0&id=a4469dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4469dcc",
  null
  
)

export default component.exports